import { gql } from '@apollo/client';

import USER_FRAGMENT from '../fragments/user';

// eslint-disable-next-line import/prefer-default-export
export const UPDATE_USER = gql`
  ${USER_FRAGMENT}
  mutation updateUser($updatedDoc: UserInput!, $filter: UserInput!) {
    updateUserEntity(updatedDoc: $updatedDoc, filter: $filter) {
      ...UserFragment
    }
  }
`;

export const ENABLE_USER = gql`
  ${USER_FRAGMENT}
  mutation enableUserEntity($id: String) {
    enableUserEntity(id: $id) {
      ...UserFragment
    }
  }
`;

export const SIGN_UP_USER = gql`
  mutation signUpUserEntity($token: String!, $updatedDoc: UserInput!) {
    signUpUserEntity(token: $token, updatedDoc: $updatedDoc) {
      firstName
      lastName
      email
      status
    }
  }
`;
